import { motion } from 'framer-motion'
import { Box } from '@chakra-ui/layout'

export const AnimatedBox = motion(Box)
